
import { Vue, Component, Prop } from 'vue-property-decorator';
import {
  Modal,
  ButtonPrimary,
  Heading,
  BaseText,
  BaseIcon
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

@Component({
  components: {
    Modal,
    ButtonPrimary,
    Heading,
    BaseText,
    BaseIcon
  }
})
export default class ModalNewInvestorProfile extends Vue {
  @Prop({ type: Boolean, required: true })
  public readonly show!: boolean;

  public readonly NebraskaColors = NebraskaColors;
  public isOpen = false;

  public handleClose() {
    this.isOpen = false;
  }

  public created() {
    this.isOpen = this.show;
  }
}
